// src/components/common/TermsModal.js
// src/components/common/TermsModal.js
import React from "react";
import "./dhl-terms-conditions-popup.css"; // Ensure this CSS file is created
import dhlLogo from "../../../logo_dhl.gif";
import closeButton from "../../../assets/close-btn.png";

const TermsModal = ({ isOpen, onClose, onAccept  }) => {
  if (!isOpen) return null;

  const handleAccept = () => {
    onAccept(true); // Send true to the parent component
    onClose(); // Close the modal
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <header className="header-gradient">
          <img src={dhlLogo} alt="DHL Logo" />
        </header>
        <button onClick={onClose} className="close-button">
         <img src={closeButton} alt="Close Button"></img>
        </button>
        <h3 className="color-red bold-text text-center top-gap">
          DHL Express Online Services Terms of Use
        </h3>
        <div className="scroll-terms-content" tabindex="0">
          <div className="term-item top-gap">
            <p className="term-number">1.</p>
            <p className="term-text bold-text">
              Scope, object of use and contractual parties
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">1.1</p>
            <p className="term-text">
              The DHL Express Online Services platform, App, or website, which
              you just use (“the Online Application") is offered by DHL
              International GmbH, Charles-de-Gaulle-Straße 20, 53113 Bonn
              ("DHL"). Through the Online Application you will be able to use
              various DHL Express Online Services (“DHL Services”), e.g.,
              tracking of shipments.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">1.2</p>
            <p className="term-text">
              The DHL Express Online Services Terms of Use ("Terms") apply to
              your use of the Online Application and the DHL Services. By
              accepting the Terms, you enter a contract with DHL on the Online
              Application and the DHL Services. However, the use of certain DHL
              Services may be subject to the respective contractual terms, which
              will be subject to separate acceptance. All transportation
              services provided by DHL Express are governed by the DHL Express
              Terms and Conditions of Carriage.
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">2.</p>
            <p className="term-text bold-text">Use of the Online Application</p>
          </div>
          <div className="term-item">
            <p className="term-number">2.1</p>
            <p className="term-text">
              To use all features of the Online Application and the DHL
              Services, you must accept the Terms. In case you do not want to
              accept the Terms, you cannot use the Online Application and DHL
              Services.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">2.2</p>
            <p className="term-text">
              You are responsible for using the Online Application and the DHL
              Services in accordance with these Terms, lawfully and in good
              faith. You are not to cause any damage or harm of any kind
              (including reputational damage) to DHL or any third party. You
              shall not use the Online Application or the DHL Services in a way
              that violates applicable law or the Terms.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">2.3</p>
            <p className="term-text">
              Certain DHL Services in the Online Application may require a fee.
              Before using a DHL Service, DHL will speci-fy if a fee is
              required.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">2.4</p>
            <p className="term-text">
              If the Online Application uses Bluetooth Low Energy technology to
              transfer both security digital keys and data from the logistics
              providers, you accept that the before mentioned is transmitted
              using this technology and process, both in terms of your own data
              as well as third party and logistic provider data.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">2.5</p>
            <p className="term-text">
              Unless otherwise specified within the DHL Services, all data,
              documents, and other information (“Electronic Data”) will be
              shared electronically within the Online Application. You authorize
              DHL to access, process and use all Electronic Data as necessary to
              perform and fulfil its obligations for the purposes specified in
              the Online Application and in the specific DHL Services.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">2.6</p>
            <p className="term-text">
              By providing electronic data to DHL, you acknowledge that you are
              responsible for the completeness and accuracy of the electronic
              data which shall be timely submitted to DHL, including but not
              limited to a detailed description of the content of the shipment.
              DHL will rely on the electronic data submitted and DHL is not
              obliged to verify its completeness or accuracy by checking against
              any paper or scanned document. You will bear all responsibility in
              case of any discrepancy between such electronic data and any paper
              or scanned document.{" "}
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">3.</p>
            <p className="term-text bold-text">Rights of Use</p>
          </div>
          <div className="term-item">
            <p className="term-number">3.1</p>
            <p className="term-text">
              Unless applicable law gives you more rights despite the
              limitations set out in this clause 3, DHL grants you the
              revocable, non-exclusive, non-transferable, limited right to
              download, install and to use the Online Ap-plication only for the
              purposes set out in clause 1.1 of these Terms. The right granted
              to you is solely for your personal, non-commercial purposes.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">3.2</p>
            <p className="term-text">
              All texts, graphics, user interfaces, databases, trademarks,
              logos, and computer code (“Content”) in the Online Application and
              the DHL Services is owned or licensed by DHL and is protected by
              copyright and trademark laws and other intellectual property
              rights. The Content includes but is not limited to the design,
              structure, selection, expression, “look and feel” and arrangement
              of the Content. Except as expressly pro-vided in these Terms, no
              Content may be processed without DHL’s prior written consent. The
              processing in-cludes – in whole or in part - copied, scraped,
              modified, cached, reproduced, republished, uploaded, trans-mitted,
              or distributed in any way to any other computer, server, website
              or other medium for publication or distribution.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">3.3</p>
            <p className="term-text">
              By way of example and without limitations, you shall not or not
              attempt to and not authorize or permit others to:
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  reverse engineer, decompile, disassemble, or otherwise attempt
                  to derive the source code form, under-lying ideas, algorithms
                  or structure of the Online Application and/or the DHL Services
                  and/or the Con-tent.{" "}
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  repackage, replicate, copy or recreate the Online Application
                  or the DHL Services or the Content.{" "}
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  modify the Online Application or the DHL Services or the
                  Content; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  publish any performance or benchmark tests or analyses
                  relating to the software or the use thereof; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  offer for sale, market, distribute, sublicense, assign, share,
                  timeshare, (re-)sell, rent, lease, or grant a security
                  interest in the Online Application or the DHL Services or
                  Content in whole or in part. You may not commercially exploit
                  in any manner any of the Content or data obtained from the
                  Online Application or from the DHL Services.{" "}
                </p>
              </div>
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">4.</p>
            <p className="term-text bold-text">Availability </p>
          </div>
          <div className="term-item">
            <p className="term-number">4.1</p>
            <p className="term-text">
              DHL will use reasonable efforts to ensure that the Online
              Application is available 365 days per year except during scheduled
              maintenance windows or during Force Majeure events. Scheduled
              maintenance windows will be pre-announced, to the best of our
              ability, on the Online Application or by email in advance.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">4.2</p>
            <p className="term-text">
              The Online Application is deemed available as long as you can
              access the DHL Services. DHL makes no spe-cific warranties
              regarding the continued operation of the Online Application, nor
              in terms of service levels for identifying or resolving reported
              issues.{" "}
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">5.</p>
            <p className="term-text bold-text">IT-Security. </p>
          </div>
          <div className="term-item">
            <p className="term-number">5.1</p>
            <p className="term-text">
              DHL ensures that it maintains appropriate security measures in
              line with International Standard Organiza-tion ISO 27001/2013.
              This is DHL’s entire obligation regarding the security of
              information and data and DHL`s IT-systems in connection with your
              use of the Online Application and the DHL Services.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">5.2</p>
            <p className="term-text">
              You are solely responsible for maintaining back-up copies of
              Electronic Data provided by you, when using DHL Services or
              retrieved by you from the DHL Services (“Your Data”). Without
              prejudice to any existing con-tractual obligations between DHL and
              you DHL shall not be required to hand over or provide access to
              Your Data, unless necessary to fulfil the purposes set out in
              clause 1.1 or otherwise agreed upon in writing.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">5.3</p>
            <p className="term-text">
              It is your responsibility to take appropriate precautions to
              ensure the security of your computer systems and networks, as well
              as the integrity and confidentiality of Your Data, e.g., without
              limitation, by activating the security features offered by DHL,
              currently eSecure, or by keeping backup copies of Your Data or by
              observ-ing all IT-security related notifications (e.g., phishing
              alerts on the Online Application).{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">5.4</p>
            <p className="term-text">
              You shall not nor attempt to nor permit third parties to:
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  gain unauthorized access to Electronic Data, which is not Your
                  Data or intended for your use or use Elec-tronic Data of third
                  parties without authorization.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  perform any security tests (e.g., pen-testing), performance
                  tests (e.g., load-testing), stress tests or simi-lar tests on
                  the Online Application.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  use any automated systems and/or software (including i.e.,
                  crawlers, spiders, search-bots, browser plug-ins, extensions,
                  add-ons or other technological means or processes), to access,
                  scrape or modify the DHL Services or the Online Application or
                  to copy, add, download, or retrieve Content from the Online
                  Application.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  interfere with, modify, disable, hinder or damage the
                  accessibility and any features, functionality or se-curity
                  controls of the Online Application or the DHL Services.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  defeat, avoid, bypass, remove, deactivate, or otherwise
                  circumvent any protection mechanisms for the Online
                  Application or the DHL Services.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  introduce viruses, trojans, worms, logic bombs or other
                  technologically harmful or malicious materials or perform
                  (distributed) denial-of-service attacks or other
                  cyber-attacks.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  procure (e.g., by way of phishing or (social) pharming) and
                  use or deploy user credentials, such as usernames, passwords,
                  credit card information.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  engage in industrial espionage to retrieve Electronic Data
                  (esp. data and/or information representing trade or business
                  secrets) by any of the above actions.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  integrate the Online Application or the DHL Services into
                  IT-systems or operate IT-systems in a way that third parties
                  or automated systems/software can have direct or indirect
                  unsecured or unauthorized ac-cess to DHL Services or the
                  Online Application. In particular, you shall take all, and
                  shall ensure that you always maintain, sufficient technical
                  and (IT-)security measures (e.g. but not limited to up-to-date
                  virus protection, anti-malware tools and/or up-to-date browser
                  version) to prevent third parties or automat-ed systems and/or
                  software from accessing, downloading, retrieving and/or making
                  available Electron-ic Data from the Online Application. The
                  measures according to this clause shall particularly include
                  the use of bot protection systems, CAPTCHA and/or the
                  monitoring and investigation of traffic spikes.
                </p>
              </div>
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">6.</p>
            <p className="term-text bold-text">
              Suspension of the use of the Online Application and the DHL
              Services
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">6.1</p>
            <p className="term-text">
              DHL may suspend or limit the use of the Online Application and the
              access to DHL Services, immediately upon notice, if:
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  DHL determines at its own discretion that there is misuse,
                  fraudulent, illegal and/or contrary to good faith use of the
                  Online Application and the DHL Services; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  DHL determines at its own discretion that there is a material
                  breach of your obligations according to these Terms; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  DHL determines at its own discretion that there is a
                  reasonable suspicion of a security incident.
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  extraordinary maintenance work is required; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  suspension or limitation is required by law, a court decision,
                  or a request from a governmental body.
                </p>
              </div>
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">6.2</p>
            <p className="term-text">
              DHL’s failure to enforce the rights and/or entitlements of these
              Terms shall not be construed as a waiver nor prevent DHL from
              demanding, at any time thereafter, your strict compliance with the
              contractual provisions.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">6.3</p>
            <p className="term-text">
              In case of a material breach of your contractual obligations,
              DHL’s right to terminate pursuant to clause 10.2 and all other
              rights and remedies it may have, remain unaffected.
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">7.</p>
            <p className="term-text bold-text">
              Export Controls, Sanctions, and Customs Laws{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">7.1</p>
            <p className="term-text">
              Export controls, economic sanctions, and customs laws and
              regulations apply to the provision of the DHL Services and your
              access to the Online Application.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">7.2</p>
            <p className="term-text">
              You agree to comply fully with all UN, EU, US, UK, and other
              applicable export controls and economic sanc-tions laws and
              regulations and, where applicable, local customs laws
              (collectively, “Trade Laws”). You rep-resent and warrant that you
              (and any company, entity, or third party on whose behalf you are
              engaged) are not listed on any applicable sanctions lists as a
              denied or restricted party. You agree and are obliged: (i) to deny
              and prevent access to the Online Application from any location
              subject to applicable broad compre-hensive sanctions or embargoes
              under applicable Trade Laws; (ii) to deny or prevent access to the
              Online Application to any individual or entity designated on any
              Denied Party Lists or owned or controlled by a per-son designated
              on any denied party list; (iii) to ensure and warrant, that you
              are not listed on any denied par-ty lists; (iv) to secure that no
              software, technology or data owned or controlled by you or by
              third parties con-tracted by or acting on your behalf, which is
              subject to prohibitions or restrictions under applicable Trade
              Laws, is used, re-/exported, transferred, or accessed without
              applicable export license, authorization or permit from relevant
              government authorities; and (v) notify DHL immediately in writing
              if one or more of the aforementioned requirements cannot be
              ensured by you.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">7.3</p>
            <p className="term-text">
              As far as DHL Services are subject to applicable local customs
              laws or Prohibitions & Restrictions, you agree (i) to provide
              true, complete and accurate information (if you identify errors or
              inaccuracies, you shall promptly notify us of the
              error/inaccuracy) and (ii) that, unless specified by a separate
              agreement in writing, we do not serve for or on behalf of you as
              Exporter for export control purposes, Exporter or Importer for
              cus-toms purposes, indirect representative or applicant or holder
              of any authorizations, licenses or permits re-lated to applicable
              Trade Laws on the import, export, transit or transfer of goods,
              including technology and software.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">7.4</p>
            <p className="term-text">
              If required to enable authorities or DHL – including any
              affiliates to DHL – to conduct export control, sanc-tions or,
              where applicable and required, customs compliance checks, you,
              upon request by DHL or the ac-cording DHL affiliate, shall
              promptly provide DHL with all relevant information pertaining to
              the particular destination, end user, Export Control
              Classification Number (ECCN), encryption byte levels, and
              particular in-tended use of the Online Application or the DHL
              Services including information on you and all information related
              to customs compliance. You will promptly notify DHL in writing if
              you become designated on a de-nied party list at any point in
              time.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">7.5</p>
            <p className="term-text">
              To the extent permitted by law, you agree to indemnify and hold
              harmless DHL against any damages, claims and costs by any third
              party, including but not limited to attorney fees and any claims,
              fines or penalties from relevant authorities, arising in
              connection with any termination of this Agreement which result
              from any vio-lation by DHL of Sanctions Laws or Export Control
              Laws, caused by your negligent breach of this provision.
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">8.</p>
            <p className="term-text bold-text">
              Warranty, Liability and Claims
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">8.1</p>
            <p className="term-text">
              No information obtained via the Online Application, or the DHL
              Services shall create any warranty not ex-pressly stated by DHL in
              these Terms.{" "}
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">8.2</p>
            <p className="term-text">
              Unless otherwise agreed in a specific services order and to the
              extent permitted by applicable law, in no event shall DHL be
              liable for any claims for loss or damage.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">8.3</p>
            <p className="term-text">
              The limitation as of clause 8.2 shall in particular not apply in
              cases of:
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  damages to life, limb, or health; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  claims based on a guarantee expressly assumed by DHL regarding
                  DHL Services; or
                </p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">intent or grossly negligence; or</p>
              </div>
              <div className="term-item">
                <p className="term-number">-</p>
                <p className="term-text">
                  liability according to the applicable product liability laws.
                </p>
              </div>
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">8.4</p>
            <p className="term-text">
              This clause 8 shall also be applicable to DHL’s legal
              representatives and/or vicarious agents if claims are asserted
              directly against them.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">8.5</p>
            <p className="term-text">
              Any claim regarding the operation of the Online Application or the
              DHL Services must be made in writing, within a period of 14
              (fourteen) days after the incident.
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">9.</p>
            <p className="term-text bold-text">
              Circumstances beyond DHL’s control
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">9.1</p>
            <p className="term-text">
              DHL is not liable for any loss or damage arising out of
              circumstances beyond DHL’s control. These include but are not
              limited to acts of God, compliance with any acts of any
              governmental or other authority, war or national emergency, riots,
              civil commotion, acts of terrorism, piracy, fire, storms or
              floods, explosion, crimi-nal acts, any information
              security-related threats or attacks (e.g. through computer
              viruses, bot attacks or other cyber-attacks), use by you of
              software tools or applications not downloaded from the Online
              Applica-tion (or other DHL-authorized websites or Apps) or not
              updated, power outages, configuration problems or malfunctions of
              your workstation or Internet connection, incorrect data or
              information entered by you, epi-demic, pandemic, lock-outs,
              strikes and other industrial action (in each case whether or not
              referring to DHL’s or subcontractors’ workforce), shortage of
              labour, materials and services and inability or delay in
              ob-taining supplies, the failure or a limitation of performance of
              communication networks and gateways of oth-er operators.
            </p>
          </div>
          <div className="term-item">
            <p className="term-number">9.2</p>
            <p className="term-text">
              DHL shall strive to mitigate the effects of such circumstances on
              the performance and/or the availability of the Online Application
              and or the specific DHL Services. A shutdown of Online Application
              or the DHL Ser-vices due to, by way of example and without
              limitation, an information security-related event or a
              cyber-attack shall always be deemed to be a mitigation action.
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">10.</p>
            <p className="term-text bold-text">Communication from DHL</p>
          </div>
          <div className="term-item">
            <p className="term-number"></p>
            <p className="term-text">
              DHL may communicate with you via the communication channel that
              you specified in the Online Application, or through notifications
              or messages in the Online Application.{" "}
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">11.</p>
            <p className="term-text bold-text">Data Protection </p>
          </div>
          <div className="term-item">
            <p className="term-number">11.1</p>
            <p className="term-text">
              DHL will collect, store, and process your personal data and the
              third party’s data you provided in accordance with applicable laws
              and the DHL Group Data Privacy Policy. Further information about
              the processing of personal data is available on the Privacy Notice
              page on the Online Application.
            </p>
          </div>
          <div className="term-item top-gap">
            <p className="term-number">12.</p>
            <p className="term-text bold-text">Governing Law </p>
          </div>
          <div className="term-item">
            <p className="term-number"></p>
            <p className="term-text">
              Unless contrary to applicable mandatory law, these Terms shall be
              governed by the laws of the country of the seat of DHL. The
              application of the United Nations Convention on Contracts for the
              International Sale of Goods is expressly excluded.
            </p>
          </div>
        </div>
        <div className="button-container">
          <button
            type="button"
            className="button-66"
            onClick={handleAccept} >
            I Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
